import gateways from "./gateways.vue";
export default gateways;